import { Button, Card, Layout, Switch, Tag, Text } from '@loadsmart/loadsmart-ui'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import isJson from 'common/helpers/isJSON'
import { IntegrationTestCaseDetail } from 'common/types/kraken-core/IntegrationTest'
import FileViewer from 'molecules/FileViewer/FileViewer'
import JsonForm from 'molecules/JsonForm/JsonForm'
import {
  IntegrationTestCaseExpectationCheckerSchema,
  IntegrationTestCaseExpectationCheckerSchemaUiSchema,
} from 'pages/IntegrationTest/schemas/IntegrationTestCaseSchema'
import { useState } from 'react'

export interface IntegrationTestCaseDetailExpectationDefinitionProps {
  testCase: IntegrationTestCaseDetail
  onChange: (propertyName: string, value: any) => void
}

export default function IntegrationTestCaseDetailExpectationDefinitionDetail(
  props: IntegrationTestCaseDetailExpectationDefinitionProps
) {
  const [rawView, setRawView] = useState<boolean>(false)
  const checkersFromProps = props.testCase.expectation_definition?.checkers
  const [checkers, setCheckers] = useState<Array<any>>(checkersFromProps as any)

  const handleChange = (value: any) => {
    props.onChange('expectation_definition', value)
  }

  return (
    <Card>
      <Card.Title>
        <Layout.Stack>
          <Text variant="heading-sm-bold">Expectation Definition</Text>
          <Text variant="body">To define what are the expectations for this test</Text>
        </Layout.Stack>
      </Card.Title>
      <Card.Separator />
      <Card.Body>
        <Layout.Stack>
          <Layout.Group>
            <Text>Raw view?</Text>
            <Switch active={rawView} onToggle={() => setRawView(c => !c)} />
          </Layout.Group>

          {rawView ? (
            <FileViewer
              content={JSON.stringify(checkers)}
              contentType="application/json"
              options={{}}
              onChange={changed => {
                if (isJson(changed)) {
                  const parsed = JSON.parse(changed)
                  setCheckers(JSON.parse(changed))
                  handleChange({
                    ...props.testCase.expectation_definition,
                    checkers: parsed,
                  })
                }
              }}
            />
          ) : null}

          {!rawView ? (
            <div>
              <Accordion>
                <AccordionSummary>
                  <Layout.Group align="center">
                    <Text>Checkers</Text>
                    {checkers && <Tag variant="accent">{checkers.length}</Tag>}
                  </Layout.Group>
                </AccordionSummary>
                <AccordionDetails>
                  <JsonForm
                    data={checkersFromProps}
                    onChange={changed => {
                      setCheckers(changed.data)
                      handleChange({
                        ...props.testCase.expectation_definition,
                        checkers: changed.data,
                      })
                    }}
                    schema={IntegrationTestCaseExpectationCheckerSchema}
                    uiSchema={IntegrationTestCaseExpectationCheckerSchemaUiSchema}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          ) : null}
        </Layout.Stack>
      </Card.Body>
    </Card>
  )
}
